export const environment = {
    production: false,
    API_URL: 'https://cibofuturo.3cengineering.it:8100/api',
    reCaptchaPK: '6LeqBFcpAAAAAPikpssBkSC6rVIsdOsgXxkmHfbx',
};